export enum PersonEntityType  {
    AgencyEmployee = 1,
    Juvenile = 2,

    Unkown = 99
}